import { useContext } from 'react';
import { SessionContext, type Session } from './session';

export function useSession(): Session {
  const session = useContext(SessionContext);
  if (!session) throw new Error('useSession must be used inside a SessionProvider');
  return session;
}
